"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const globalVariables_1 = require("../../../../common/globalVariables");
const Search_1 = __importDefault(require("../../Search/Search"));
const SearchModal = styled_components_1.default.div `
  margin: 16px 12px;
  max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;

  @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px) {
    margin: 16px auto;
  }
`;
const SearchContent = ({ onClose }) => (react_1.default.createElement(SearchModal, null,
    react_1.default.createElement(Search_1.default, { isVenueStartScreen: true, onClose: onClose })));
exports.default = SearchContent;
